import { FC } from "react";
import "./styles.scss";
import { PageShell } from "../PageShell";
import { useTranslation } from "../../../hooks/useTranslation";
import { VISION_VIDEO_URL } from "../../base/TutorialsModal/TutorialVideo";
import visionBanner from "../../../assets/images/landing/banners/vision-banner.jpg";

export const VisionPage: FC = () => {
  const { p } = useTranslation("landing_vision");

  return (
    <PageShell>
      <div className="landing-vision-page">
        <h1 className="landing-vision-page__heading">{p("heading")}</h1>
        <p className="landing-vision-page__subtitle">
          {p("subtitle_line1")}
          <br className="landing-vision-page__subtitle-break" /> {p("subtitle_line2")}
        </p>

        {/* The film leads the page; the scene illustration moved to the foot of it. */}
        <div className="landing-vision-page__media">
          <video
            controls
            playsInline
            preload="metadata"
            src={VISION_VIDEO_URL}
            className="landing-vision-page__video"
          />
        </div>

        <p className="landing-vision-page__text">{p("intro_1")}</p>
        <p className="landing-vision-page__text">{p("intro_2")}</p>

        <h2 className="landing-vision-page__section-heading">{p("horizon_heading")}</h2>
        <p className="landing-vision-page__text">{p("horizon_p1")}</p>
        <p className="landing-vision-page__text">{p("horizon_p2")}</p>

        <h2 className="landing-vision-page__section-heading">{p("powers_heading")}</h2>
        <p className="landing-vision-page__text">{p("powers_intro")}</p>
        <ul className="landing-vision-page__list">
          <li>
            <strong>{p("powers_bullet_1_title")}</strong> {p("powers_bullet_1_text")}
          </li>
          <li>
            <strong>{p("powers_bullet_2_title")}</strong> {p("powers_bullet_2_text")}
          </li>
          <li>
            <strong>{p("powers_bullet_3_title")}</strong> {p("powers_bullet_3_text")}
          </li>
        </ul>

        <h2 className="landing-vision-page__section-heading">{p("fulfilling_heading")}</h2>
        <p className="landing-vision-page__text">{p("fulfilling_p1")}</p>
        <p className="landing-vision-page__text">{p("fulfilling_p2")}</p>

        <img src={visionBanner} alt="" className="landing-vision-page__banner" />
      </div>
    </PageShell>
  );
};
